var fs = require('fs');
var ejs = require('ejs');
// const { logger } = require('../config/logger');

function toHTML(ejsTemplateURL, data) {
  return new Promise(function (resolve, reject) {
    fs.readFile(ejsTemplateURL, 'utf8', function (error, response) {
      if (error) {
        // logger.log({ level: 'info', message: error });
        reject(error);
      } else {
        var html = ejs.render(response, data);
        resolve(html);
      }
    });
  });
}

module.exports = {
  toHTML,
};
